import React from 'react';
import propTypes from 'prop-types';
import Text from './Text';
import Image from './Image';
import Hero from './Hero';
import Heading from './Heading';
import Video from './Video';
import PropTypeMap from '../utils/PropTypeMap';
import ImageCarousel from './ImageCarousel';
import Youtube from './Youtube';

const Column = ({ type, data, size }) => {
	// return a component for the respective column type
	// current available types are: text

	// TODO: force type to lowercase to account for missplellings TEXT = text
	const columnType = () => {
		switch (type) {
			case 'text':
				return <Text data={data} />;
			case 'image':
				return <Image data={data} />;
			case 'hero':
				return <Hero data={data} />;
			case 'heading':
				return <Heading data={data} />;
			case 'imageText':
				return (
					<React.Fragment>
						<Image data={data} />
						<Text data={data} />
					</React.Fragment>
				);
			case 'carousel':
				return <ImageCarousel data={data} />;
			case 'video':
				return <Video data={data} />;
			case 'videoText':
				return (
					<React.Fragment>
						<Video data={data} />
						<Text data={data} />
					</React.Fragment>
				);
			case 'youtube':
				return <Youtube data={data} />;
			default:
				return <React.Fragment />;
		}
	};
	// create column classes based on sizes object
	const columnClasses = () => {
		let classes =
			data.classes !== undefined && data.classes !== null
				? `${data.classes} `
				: '';
		const classesArray = Object.keys(size);
		classesArray.forEach((breakpoint) => {
			if (size[breakpoint] === 0) return classes;
			classes += `col-${breakpoint}-${size[breakpoint]} `;
			return classes;
		});
		return classes;
	};

	Column.defaultProps = {
		size: {
			xs: 12
		}
	};

	Column.propTypes = {
		type: propTypes.string.isRequired,
		data: propTypes.shape(PropTypeMap[type || ''].data).isRequired,
		size: propTypes.shape({})
	};

	return <div className={columnClasses(size)}>{columnType(type)}</div>;
};

export default Column;
